var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedSurvey === null,
              expression: "selectedSurvey === null"
            }
          ],
          ref: "table"
        },
        [
          _c("vue-good-table", {
            attrs: {
              columns: _vm.columnsConfig,
              rows: _vm.store.surveys,
              searchOptions: _vm.searchOptions,
              paginationOptions: _vm.paginationOptions
            },
            scopedSlots: _vm._u([
              {
                key: "table-row",
                fn: function(props) {
                  return [
                    props.column.isSurveyNameColumn
                      ? _c(
                          "div",
                          { staticClass: "d-flex flex-row" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.formattedRow[props.column.field]) +
                                "\n          "
                            ),
                            _c("AttachmentsButtonIfPresent", {
                              staticClass: "ml-auto",
                              attrs: { surveyId: props.row.id }
                            })
                          ],
                          1
                        )
                      : props.column.isActions
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-group",
                            attrs: { role: "group" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                on: {
                                  click: function($event) {
                                    return _vm.takeSurvey(props.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("surveyTake")) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                on: {
                                  click: function($event) {
                                    return _vm.copySurveyUrl(props.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("surveyCopyUrl")) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-sm",
                                on: {
                                  click: function($event) {
                                    return _vm.getQr(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-qrcode" })]
                            ),
                            _vm._v(" "),
                            _vm.canSeeResults
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-warning",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToResults(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("surveyResults")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canSeeEdit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function($event) {
                                        return _vm.editSurvey(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("surveyEdit")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canSeeEdit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    on: {
                                      click: function($event) {
                                        return _vm.openCopyTo(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("surveyCopy")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canSeeEdit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteSurvey(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("surveyDelete")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canSeeEdit
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteResultsOfSurvey(
                                          props.row
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("surveyResultsDelete")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.formattedRow[props.column.field]) +
                              "\n        "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.canSeeEdit
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.newSurveyName === null,
                      expression: "newSurveyName === null"
                    }
                  ],
                  staticClass: "btn btn-primary my-1",
                  on: {
                    click: function($event) {
                      _vm.newSurveyName = ""
                      _vm.$nextTick(function() {
                        _vm.$refs.newSurvey.focus()
                      })
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("surveyNew")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.newSurveyName !== null,
                  expression: "newSurveyName !== null"
                }
              ],
              staticClass: "input-group my-1"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newSurveyName,
                    expression: "newSurveyName"
                  }
                ],
                ref: "newSurvey",
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.newSurveyName },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.newSurvey.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      )
                        return null
                      $event.preventDefault()
                      $event.stopPropagation()
                      _vm.newSurveyName = null
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.newSurveyName = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.newSurvey }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("btnCreate")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    attrs: { type: "button" },
                    on: { click: _vm.openImportModal }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("surveyImport")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.newSurveyName = null
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedSurvey !== null,
              expression: "selectedSurvey !== null"
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "fixed",
                top: "0",
                right: "0",
                "z-index": "1"
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary m-1",
                  on: { click: _vm.backToList }
                },
                [_vm._v(_vm._s(_vm.$t("surveyBackToList")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-primary m-1", on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("btnSave")))]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            ref: "creator",
            staticStyle: {
              "margin-left": "-1rem",
              "margin-right": "-1rem",
              height: "100vh"
            },
            attrs: { id: "surveyCreator" }
          }),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "designer-overlay" },
                [_c("Spinner", { attrs: { type: "secondary" } })],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("CopyModal", { ref: "copyModal", on: { copyTo: _vm.onCopySurvey } }),
      _vm._v(" "),
      _c("ConvertModal", {
        ref: "convertModal",
        on: { imported: _vm.importedDone }
      }),
      _vm._v(" "),
      _c("QuestionGeneratorModal", {
        ref: "questionGeneratorModal",
        on: { ok: _vm.onGenerateQuestions }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }